import { LucideIcon } from "lucide-react";
import { cn } from "~/lib/utils";
import { Card, CardContent } from "./card";

interface StatsCardProps {
  title: string | number;
  description: string;
  icon?: LucideIcon;
  iconColor?: string;
  titleColor?: string;
  className?: string;
  size?: "default" | "compact";
  isLoading?: boolean;
}

export function StatsCard({
  title,
  description,
  icon: Icon,
  iconColor = "text-muted-foreground",
  titleColor = "",
  className,
  size = "default",
  isLoading = false,
}: StatsCardProps) {
  const compact = size === "compact";

  return (
    <Card className={cn("border-0 shadow-none bg-background", compact && "py-3 gap-0", className)}>
      <CardContent className={cn(compact && "px-4")}>
        <div className="flex items-center justify-between">
          <div>
            {isLoading ? (
              <div className="space-y-2">
                <div
                  className={cn(
                    "bg-muted animate-pulse rounded",
                    compact ? "h-5 w-12" : "h-6 w-16"
                  )}
                />
                <div
                  className={cn(
                    "bg-muted animate-pulse rounded",
                    compact ? "h-3 w-20" : "h-4 w-24"
                  )}
                />
              </div>
            ) : (
              <>
                <p className={cn("font-bold", compact ? "text-xl" : "text-2xl", titleColor)}>
                  {title}
                </p>
                <p className="text-xs text-muted-foreground">{description}</p>
              </>
            )}
          </div>
          {Icon && (
            <Icon
              className={cn(iconColor, compact ? "h-6 w-6" : "h-8 w-8", isLoading && "opacity-50")}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
}
